import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/adminAuth';
import { message, Spin } from 'antd';
import { useEffect, useState } from 'react';
import supabase from '../config/supabaseConfig';

interface AdminRouteProps {
    children: React.ReactNode;
}

export const AdminRoute = ({ children }: AdminRouteProps) => {
    const { admin, isLoading } = useAdminAuth();
    const [isApprovedAdmin, setIsApprovedAdmin] = useState<boolean | null>(null);
    const [isChecking, setIsChecking] = useState(true);

    // Check if the user is an approved admin
    useEffect(() => {
        const checkIfApprovedAdmin = async () => {
            if (!admin) {
                setIsApprovedAdmin(false);
                setIsChecking(false);
                return;
            }

            try {
                // Query the admins table
                const { data, error } = await supabase
                    .from('admins')
                    .select('approved')
                    .eq('id', admin.id)
                    .single();

                if (error) {
                    /* Removed console statement */
                    setIsApprovedAdmin(false);
                } else {
                    const approved = data?.approved ?? false;
                    setIsApprovedAdmin(approved);
                }
            } catch {
                /* Removed console statement */
                message.error("Impossible de vérifier votre statut d'administrateur");
                setIsApprovedAdmin(false);
            } finally {
                setIsChecking(false);
            }
        };

        checkIfApprovedAdmin();
    }, [admin]);

    // Show loading state
    if (isLoading || isChecking) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <Spin size="large" tip="Vérification de votre session d'administrateur..." />
            </div>
        );
    }

    // Redirect if not authenticated
    if (!admin) {
        return <Navigate to="/login-admin" />;
    }

    // Redirect if authenticated but not an approved admin
    if (!isApprovedAdmin) {
        return <Navigate to="/login-admin" />;
    }
    return <>{children}</>;
};